import { Box, Collapse, Text } from "@chakra-ui/react";
import AddNewCardToggle from "views/customer/order/components/AddNewCardToggle";
import NewCardForm from "views/customer/order/components/NewCardForm";
import SavedCardsList from "views/customer/order/components/SavedCardsList";

export default function CardsPanel(props: {
  cards: any[];
  selectedPaymentInfo: any;
  openCardInputForm: boolean;
  cardBrand: string;
  cardHolderName: string;
  setCardHolderName: (name: string) => void;
  onSelectSavedCard: (card: any) => void;
  onRemoveCard: (cardId: number) => void;
  onToggleAddNewCard: () => void;
}) {
  const {
    cards,
    selectedPaymentInfo,
    openCardInputForm,
    cardBrand,
    cardHolderName,
    setCardHolderName,
    onSelectSavedCard,
    onRemoveCard,
    onToggleAddNewCard,
  } = props;

  return (
    <Box p={{ base: "14px", md: "16px" }} borderRadius="12px" border="1px solid #E5E7EB" bg="#FFF">
      <Text fontSize="16px" lineHeight="24px" fontWeight="600" color="#0B0E10">
        Cards
      </Text>

      <Box mt="14px">
        {cards?.length > 0 ? (
          <SavedCardsList
            cards={cards}
            selectedCard={selectedPaymentInfo}
            onSelectCard={onSelectSavedCard}
            onRemoveCard={onRemoveCard}
          />
        ) : (
          <Text fontSize="14px" color="#667085">
            No saved cards yet.
          </Text>
        )}
      </Box>

      <AddNewCardToggle open={openCardInputForm} onToggle={onToggleAddNewCard} isDisabled={false} />

      <Collapse in={openCardInputForm} animateOpacity>
        <Box>
          <NewCardForm
            cardBrand={cardBrand}
            cardHolderName={cardHolderName}
            setCardHolderName={setCardHolderName}
            onFocusStripe={() => {}}
          />
        </Box>
      </Collapse>
    </Box>
  );
}
